import { render, staticRenderFns } from "./ExpandedCard.vue?vue&type=template&id=e61a085e"
import script from "./ExpandedCard.vue?vue&type=script&lang=js"
export * from "./ExpandedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports